export default {
    container: {
        width: "100%",
        padding: "16px",
        border: "1px solid",
        borderColor: "greyscale.200",
        borderRadius: "8px",
        background: "#fff"
    },
    headerTitleRow: {
        display: "flex",
        alignItems: "center",
        gap: 1
    },
    headerIcon: {
        width: 18,
        height: 18,
        "& path:first-of-type": { fill: "#7930D9", stroke: "transparent" }
    },
    headerSubtitleRow: {
        display: "flex",
        alignItems: "center",
        gap: 1,
        mt: 1
    },
    inputWrapper: {
        position: "relative"
    },
    input: {
        borderRadius: "8px",
        backgroundColor: "background.paper",
        fontSize: 14,
        "& .MuiInputBase-input::placeholder": {
            color: "greyscale.700",
            opacity: 1
        }
    },
    sendButtonWrapper: {
        position: "absolute",
        right: "1px",
        top: "1px"
    },
    mcpPromo: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "12px",
        mt: "14px",
        p: "12px",
        borderRadius: "8px",
        backgroundColor: "primary.50"
    },
    mcpPromoIconBadge: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 32,
        height: 32,
        borderRadius: "6px",
        backgroundColor: "primary.700"
    },
    mcpPromoIcon: {
        width: 20,
        height: 20,
        fill: "none",
        "& path": { stroke: "#fff" }
    },
    mcpPromoText: {
        flex: "1 1 260px",
        minWidth: 0
    },
    mcpPromoHeadlineRow: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "6px"
    },
    mcpPromoHeadline: {
        fontWeight: 600
    },
    mcpPromoBadge: {
        flexShrink: 0,
        backgroundColor: "transparent",
        "&.MuiChip-root": {
            padding: 1 / 2,
            borderRadius: "4px",
            border: ({ palette }) => `1px solid ${palette.secondary[500]}`,
            height: ({ spacing }) => spacing(2),
            "&:hover": {
                backgroundColor: "transparent"
            }
        }
    },
    mcpPromoCta: {
        flexShrink: 0,
        whiteSpace: "nowrap"
    }
};
